import { render, staticRenderFns } from "./EditarContatoRealizadoDialog.vue?vue&type=template&id=5f5ae646&scoped=true&"
import script from "./EditarContatoRealizadoDialog.vue?vue&type=script&lang=js&"
export * from "./EditarContatoRealizadoDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditarContatoRealizadoDialog.vue?vue&type=style&index=0&id=5f5ae646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ae646",
  null
  
)

export default component.exports